import { PostRequest } from '@/util/http';

export function APIFetchExpectations(params: any) {
  return PostRequest('kpi/predictionAndWTE', params);
} // APIFetchExpectations
